import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {PageType} from '../../models/page-type';

@Injectable({
  providedIn: 'root'
})
export class PageTypeService extends AbstractModelService<PageType> {

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/page-type', PageType);
  }
}
